/** A seeded random source: the same seed always gives the same sequence. */
export interface Random {
  /** The next number in the sequence, uniform in [0, 1). */
  next(): number
  /** The next bell-shaped number: the mean of three uniforms, in (-1, 1), centred on 0. Uses three draws. */
  gauss(): number
  /** Starts the sequence over from the seed. */
  reset(): void
}

/**
 * Mulberry32. Deterministic: the particles, and so every frame at a given
 * time, depend on the sequence for a seed never changing. Changing this
 * algorithm or a seed changes the picture.
 */
export function createRandom(seed: number): Random {
  let state = seed

  return { next, gauss, reset }

  function reset() {
    state = seed
  }

  function gauss(): number {
    return (next() + next() + next() - 1.5) / 1.5
  }

  function next(): number {
    state = (state + 0x6d2b79f5) | 0
    let t = Math.imul(state ^ (state >>> 15), 1 | state)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
